var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6 41.5999C43.3673 41.5999 44.8 40.1673 44.8 38.4C44.8 36.6326 43.3673 35.2 41.6 35.2C39.8327 35.2 38.4 36.6326 38.4 38.4C38.4 40.1673 39.8327 41.5999 41.6 41.5999Z",
    fill: "#CA1130"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2001 8.00005C27.2001 9.76805 25.7681 9.60005 24 9.60005C22.232 9.60005 20.8 9.76805 20.8 8.00005C20.8 6.23205 22.232 4.80005 24 4.80005C25.7681 4.80005 27.2001 6.23205 27.2001 8.00005Z",
    fill: "#CA1130"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.39995 41.5999C8.16726 41.5999 9.59995 40.1673 9.59995 38.4C9.59995 36.6326 8.16726 35.2 6.39995 35.2C4.63264 35.2 3.19995 36.6326 3.19995 38.4C3.19995 40.1673 4.63264 41.5999 6.39995 41.5999Z",
    fill: "#CA1130"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9377 6.7359L24.0001 6.3999L21.0625 6.7359L3.68005 36.7167L6.63045 41.5999H24.0001H41.3697L44.3201 36.7167L26.9377 6.7359ZM25.9393 18.1759L25.6193 28.5327H22.3809L22.0609 18.1759H25.9393ZM24.0049 35.5023C22.6801 35.5023 21.8881 34.7967 21.8881 33.6111C21.8881 32.4031 22.6785 31.6975 24.0049 31.6975C25.3201 31.6975 26.1105 32.4031 26.1105 33.6111C26.1105 34.7967 25.3201 35.5023 24.0049 35.5023Z",
    fill: "#CA1130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.cca9d3c535433fdc3243de52f42f948d.svg";
export { ForwardRef as ReactComponent };